var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pa-4"},[_c('manage-advertising',{scopedSlots:_vm._u([{key:"tabs",fn:function(){return [_c('v-tab',[_vm._v(" مدیریت رزروها ")])]},proxy:true},{key:"items",fn:function(){return [_c('v-tab-item',[_c('commercialListItemSevenAdmin')],1)]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }